
import BaseInputFile from "@/components/forms/BaseInputFile.vue";
import { formModal } from "@/mixins/modal/form-modal.js";
// import { required, email, maxLength, numeric, requiredIf } from "vuelidate/lib/validators";
import DatePicker from "@/components/forms/DatePicker.vue";
import { DoctorsRepository } from "@/modules/doctors/doctors.repository.js";
import Loader from "@/components/Loader.vue";
// import { messageHelper } from "@/services/validation-helper";
// import dayjs from "dayjs";
import jsonToFormData from "@ajoelp/json-to-formdata";

import { VSelectItem } from "@/core/interfaces/v-select.interface";
import { ClinicsReference, MISClinic } from "@/core/references/clinics";
import { DoctorCategoriesReference } from "@/core/references/doctor-categories";
import { DoctorEducationsReference } from "@/core/references/doctor-educations";
import { ScientificDegreesReference } from "@/core/references/scientific-degrees";
// import { SpecializationsReference } from "@/core/references/specializations";
import { UniversitiesReference } from "@/core/references/universities";

interface Org {
  organization_id: number;
  structures: { [key: string]: string }[];
}

import Vue from "vue";
import { SpecializationsReference } from "@/core/references/specializations/specializations.reference";
import { Doctor } from "@/modules/doctors/Doctor.js";
import { required } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "EditDoctor",
  components: { BaseInputFile, DatePicker, Loader },
  props: {
    doctorId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formError: "",
      categories: [] as VSelectItem[],
      scientificDegrees: [] as VSelectItem[],
      educations: [] as VSelectItem[],
      clinicsLoading: false,
      clinics: [] as MISClinic[],
      selectedClinic: null as MISClinic | null,
      universities: [] as VSelectItem[],
      universitiesLoading: false,
      selectedUniversity: null as VSelectItem | null,

      specializations: [] as VSelectItem[],
      selectedSpecialization: null as VSelectItem | null,
      specializationsLoading: false,

      loadingForm: false,
      doctor: {} as Doctor,
      commonErrors: "",
      birthdatePicker: false,
      form: {
        specializations: [],
        clinics: [],
        universities: [],
        doctor_category: "",
        license_number: "",
        license_date: "",
        short_description: "",
        long_description: "",
        // scientific_degree: "",
        education: "",
        organization_id: null,
        position_id: "",
        mis_organization_id: "",
      } as {
        specializations: { id: number | string; name: string }[];
        organization_id: number | null;
        clinics: { id: number; name: string; work_date_from: string; work_date_to: string }[];
        doctor_category: string;
        license_number: string;
        license_date: string;
        short_description: string;
        long_description: string;
        education: string;
        universities: { id: number; name: string; finish_date: string }[];
        position_id: string | { id: string };
        mis_organization_id: string;
      },
      orgList: [] as Org[],
      misOrgs: [],
      positionsList: [],
      fetchOrg: false,
    };
  },
  mixins: [formModal],

  validations: {
    form: {
      clinics: {
        $each: {
          work_date_from: { required },
        },
      },
      universities: {
        $each: {
          finish_date: { required },
        },
      },
    },
  },
  computed: {
    currentOrg(): Org | null | undefined {
      if (this.orgList && this.orgList.length && this.form.organization_id) {
        return this.orgList.find(el => el.organization_id === this.form.organization_id);
      }
      return null;
    },
    structuresList(): { [key: string]: string }[] {
      if (this.currentOrg) {
        return this.currentOrg.structures;
      }
      return [];
    },
  },
  methods: {
    removeFormReferenceItem(filed: string, item: { id: number }): void {
      this.form[filed] = this.form[filed].filter((fieldItem: { id: number }) => fieldItem.id !== item.id);
    },
    loadReferences: async function(): Promise<void> {
      const [categories, scientificDegrees, educations, clinics] = await Promise.all([
        this.$registry.get(DoctorCategoriesReference).getSelectItems(),
        this.$registry.get(ScientificDegreesReference).getSelectItems(),
        this.$registry.get(DoctorEducationsReference).getSelectItems(),
        this.$registry.get(ClinicsReference).getList(),
      ]);

      this.categories = categories;
      this.scientificDegrees = scientificDegrees;
      this.educations = educations;
      this.clinics = clinics;
    },

    addClinic(): void {
      if (!this.selectedClinic) {
        (this.$refs.clinicsField as HTMLElement).focus();
        return;
      }
      const addedClinics = this.form.clinics.map(clinic => clinic.id);
      if (addedClinics.includes(this.selectedClinic.mis_organization_id)) {
        this.$notify.showMessage("Такое место работы уже добавлено", "error");

        return;
      }
      this.form.clinics.push({
        id: this.selectedClinic.mis_organization_id as number,
        name: this.selectedClinic.mis_organization_name as string,
        work_date_from: "",
        work_date_to: "",
      });
      this.selectedClinic = null;
    },
    async findSpecialization(query: string): Promise<void> {
      if (!query || query.length < 2) {
        return;
      }

      await this.$registry.get(SpecializationsReference).getList(query);
      this.specializations = this.$registry.get(SpecializationsReference).getDoctorSelectItems();
    },
    addSpecialization(): void {
      if (!this.selectedSpecialization) {
        (this.$refs.specializationsFiled as HTMLElement).focus();
        return;
      }
      if (this.form.specializations) {
        const addedSpec = this.form.specializations.map(spec => spec.id);
        if (addedSpec.includes(this.selectedSpecialization.value)) {
          this.$notify.showMessage("Такая специальность уже добавлена", "error");

          return;
        }
      }
      this.form.specializations.push({
        id: Number(this.selectedSpecialization.value),
        name: this.selectedSpecialization.text as string,
      });
      this.selectedSpecialization = null;
    },

    async findUniversity(query): Promise<void> {
      if (!query || query.length < 2) {
        return;
      }

      await this.$registry.get(UniversitiesReference).getList(query);
      this.universities = this.$registry.get(UniversitiesReference).getSelectItems();
    },

    addUniversity(): void {
      if (!this.selectedUniversity) {
        (this.$refs.universitiesField as HTMLElement).focus();
        return;
      }
      if (this.form.universities) {
        const addedUni = this.form.universities.map(spec => spec.id);
        if (addedUni.includes(Number(this.selectedUniversity.value))) {
          this.$notify.showMessage("Такое место учебы уже добавлено", "error");

          return;
        }
        this.form.universities.push({
          id: this.selectedUniversity.value as number,
          name: this.selectedUniversity.text as string,
          finish_date: "",
        });
      }
      this.selectedUniversity = null;
    },

    loading(val: boolean): void {
      this.loadingForm = val;
      this.$emit("loading", val);
    },

    async submit(): Promise<void> {
      this.formError = "";
      this.$v.form.$touch();
      console.log(`this.$v.form.$error =>`, this.$v.form);
      if (this.$v.form.$pending || this.$v.form.$error) {
        this.formError = "Заполните обязательные поля";
        this.$notify.showMessage("Заполните обязательные поля", "error");
        return;
      }
      try {
        const preparedForm = Object.assign({}, this.form);

        const { data } = await this.$http.post(
          `v1/doctors/${this.doctorId}`,
          jsonToFormData(
            {
              ...preparedForm,
              specializations: preparedForm.specializations.map(s => s.id),
            },
            { excludeNull: false },
          ),
        );
        DoctorsRepository.updateById(this.doctorId, data.data);
        this.$notify.showMessage("Доктор сохранён", "success");
        this.close();
      } catch (e) {
        console.log(e.response);
        this.formError = "Ошибка отправки данных доктора";
        this.$notify.showMessage(e.response.data?.message || "Ошибка сохранения доктора", "error");
      }
    },
  },
  async created(): Promise<void> {
    await this.loadReferences();
    this.doctor = await DoctorsRepository.getById(this.doctorId, true);
    if (this.doctor) {
      console.log(`this.doctor =>`, this.doctor);
      this.form.clinics = this.doctor.clinics || [];
      this.form.universities = this.doctor.universities || [];
      this.form.doctor_category = this.doctor.doctor_category;
      this.form.license_number = this.doctor.license_number;
      this.form.license_date = this.doctor.license_date;
      this.form.short_description = this.doctor.short_description;
      this.form.long_description = this.doctor.long_description;
      this.form.education = this.doctor.education;
      this.form.specializations = this.doctor.specializations || [];
      // scientific_degree = this.doctor.scientific_degree
    }
  },
});
